import { Injectable } from '@angular/core';
import type { CacheSettings } from '@hyundai/shared-lib';
import { injectCacheSettings } from '../providers/cache.token';

@Injectable({ providedIn: 'root' })
export class CacheService {
    protected readonly cacheSettings = injectCacheSettings();

    setCacheSettings(settings: Partial<CacheSettings>): void {
        if (!this.cacheSettings) {
            return;
        }
        Object.assign(this.cacheSettings, settings);
    }
}
